"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isString = void 0;
/**
 * Validates if the value is a string
 * @public
 *
 * @param arg - The argument to validate.
 *
 * @returns A boolean indicating if the arg is a String or not.
 *
 * @example
 * ```ts
 * const result = isString('string');
 * console.log(result);
 * // -> true
 * ```
 */
function isString(arg) {
    return typeof arg === 'string';
}
exports.isString = isString;
//# sourceMappingURL=is-string.js.map